<!-- 范围数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == 0">
                                <!-- 主要信息 -->
                                <el-form ref="sendDataInfo" :model="sendDataInfo" inline size="mini" :show-message="false" label-width="150px">
                                    <el-form-item label="父级菜单" prop="parentId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('父级菜单')" v-html="$common.htmlLabel('父级菜单')"></label>
                                        <el-cascader ref="elCascader" class="form_codition" :props="{ emitPath: false,checkStrictly:true }" v-model="sendDataInfo.parentId" :options="classifyList"></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="分类名称" prop="categoryName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('分类名称')" v-html="$common.htmlLabel('分类名称')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.categoryName"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div style="text-align:center; margin-top:20px;">
                    <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "categoryManageAction",
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            classifyList: [],
            sendDataInfo: {
                categoryName: '',
                parentId: '',
                id: '',
            },
            tabForm: [],
            showTabs: "",
            isLoaded: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // handleChange() {
        //     setTimeout(() => {
        //         var node = this.$refs['elCascader'].getCheckedNodes()[0]
        //         if (node) {
        //             this.sendDataInfo.parentId = node.value
        //         } else {
        //             this.sendDataInfo.parentId = ""
        //         }
        //     }, 100)
        // },
        //确认新增
        sendDataAction(formName1) {
            console.log(this.sendDataInfo);

            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var responseData;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            // delete sendData.parentIds
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.categoryadd(sendData);
            } else if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.carouseClassifyupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //取消
        initActionBox() {
            this.init();
            this.$emit("drawerCancel");
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "parentIds") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
        },
        //父级传入
        openBox(cate, formData, oldData = "") {
            this.showTabs = this.dataActionBox.boxTitle + '字典'
            this.classifyList = this.actionData.classifyList
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增";
                this.dataActionBox.openMode = "ltr";
            } else if (cate == 1) {
                this.dataActionBox.boxTitle = "编辑";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
                // this.sendDataInfo.parentIds = dataInfo.parentId
            } else {
                this.dataActionBox.boxTitle = "查看";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            }
            this.filterMainField()
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },
        // 过滤表单不同类型
        filterMainField() {
            this.tabForm = [
                {
                    jciName: this.dataActionBox.boxTitle + '字典',
                    jurconfigform: []
                }
            ]
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.init();
        var params = this.actionData;
        this.openBox(params.cate, params.formData, params.oldData[0]);
        this.isLoaded = true;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
